import NextLink from 'next/link'
import { forwardRef, type ComponentPropsWithoutRef } from 'react'

export type LinkProps = Omit<ComponentPropsWithoutRef<typeof NextLink>, 'prefetch'>

// Keep Pages Router hover/touch prefetching, without loading every visible route.
const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <NextLink {...props} prefetch={false} ref={ref} />
))

Link.displayName = 'Link'

export default Link
